"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 * no description
 */
class AssetApi extends runtime.BaseAPI {
    /**
     * Uploads an asset to the asset manager for admins.
     */
    async createAssetManagerAssetRaw(requestParameters) {
        if (requestParameters.asset === null || requestParameters.asset === undefined) {
            throw new runtime.RequiredError('asset', 'Required parameter requestParameters.asset was null or undefined when calling createAssetManagerAsset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.asset !== undefined) {
            formParams.append('asset', requestParameters.asset);
        }
        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name);
        }
        if (requestParameters.description !== undefined) {
            formParams.append('description', requestParameters.description);
        }
        if (requestParameters.urlExtension !== undefined) {
            formParams.append('urlExtension', requestParameters.urlExtension);
        }
        const response = await this.request({
            path: `/asset/create_asset_manager_asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Uploads an asset to the asset manager for admins.
     */
    async createAssetManagerAsset(requestParameters) {
        await this.createAssetManagerAssetRaw(requestParameters);
    }
    /**
     * Uploads an asset to the asset manager for users.
     */
    async createUserAssetManagerAssetRaw(requestParameters) {
        if (requestParameters.asset === null || requestParameters.asset === undefined) {
            throw new runtime.RequiredError('asset', 'Required parameter requestParameters.asset was null or undefined when calling createUserAssetManagerAsset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.asset !== undefined) {
            formParams.append('asset', requestParameters.asset);
        }
        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name);
        }
        if (requestParameters.description !== undefined) {
            formParams.append('description', requestParameters.description);
        }
        if (requestParameters.urlExtension !== undefined) {
            formParams.append('urlExtension', requestParameters.urlExtension);
        }
        const response = await this.request({
            path: `/asset/create_user_asset_manager_asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Uploads an asset to the asset manager for users.
     */
    async createUserAssetManagerAsset(requestParameters) {
        await this.createUserAssetManagerAssetRaw(requestParameters);
    }
    /**
     */
    async deleteTournamentAssetRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/delete_tournament_asset`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.IDBodyToJSON(requestParameters.iDBody),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteTournamentAsset(requestParameters) {
        await this.deleteTournamentAssetRaw(requestParameters);
    }
    /**
     * Edits an asset to the asset manager for admins.
     */
    async editTournamentAssetRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.id !== undefined) {
            formParams.append('_id', requestParameters.id);
        }
        if (requestParameters.asset !== undefined) {
            formParams.append('asset', requestParameters.asset);
        }
        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name);
        }
        if (requestParameters.description !== undefined) {
            formParams.append('description', requestParameters.description);
        }
        const response = await this.request({
            path: `/asset/edit_tournament_asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Edits an asset to the asset manager for admins.
     */
    async editTournamentAsset(requestParameters) {
        await this.editTournamentAssetRaw(requestParameters);
    }
    /**
     * Gets all eligible assets for the asset manager.
     */
    async getAssetManagerAssetsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/get_asset_manager_assets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.AssetFromJSON));
    }
    /**
     * Gets all eligible assets for the asset manager.
     */
    async getAssetManagerAssets() {
        const response = await this.getAssetManagerAssetsRaw();
        return await response.value();
    }
    /**
     * Gets the ads for this tournament
     */
    async getPairedTournamentAssetsRaw(requestParameters) {
        if (requestParameters.tournamentID === null || requestParameters.tournamentID === undefined) {
            throw new runtime.RequiredError('tournamentID', 'Required parameter requestParameters.tournamentID was null or undefined when calling getPairedTournamentAssets.');
        }
        const queryParameters = {};
        if (requestParameters.tournamentID !== undefined) {
            queryParameters['tournamentID'] = requestParameters.tournamentID;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/get_paired_tournament_assets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GetPairedTournamentAssetsResponseFromJSON(jsonValue));
    }
    /**
     * Gets the ads for this tournament
     */
    async getPairedTournamentAssets(requestParameters) {
        const response = await this.getPairedTournamentAssetsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Used to tell how much storage space the user has used, has left, and what the total amount allowed is.
     */
    async getStorageDetailsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/get_storage_details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.StorageDetailsFromJSON(jsonValue));
    }
    /**
     * Used to tell how much storage space the user has used, has left, and what the total amount allowed is.
     */
    async getStorageDetails() {
        const response = await this.getStorageDetailsRaw();
        return await response.value();
    }
    /**
     * Gets the assets for this tournament
     */
    async getTournamentAssetsRaw(requestParameters) {
        if (requestParameters.tournamentID === null || requestParameters.tournamentID === undefined) {
            throw new runtime.RequiredError('tournamentID', 'Required parameter requestParameters.tournamentID was null or undefined when calling getTournamentAssets.');
        }
        const queryParameters = {};
        if (requestParameters.tournamentID !== undefined) {
            queryParameters['tournamentID'] = requestParameters.tournamentID;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/get_tournament_assets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.AssetFromJSON));
    }
    /**
     * Gets the assets for this tournament
     */
    async getTournamentAssets(requestParameters) {
        const response = await this.getTournamentAssetsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets all assets this user owns from the user asset manager.
     */
    async getUserAssetManagerAssetsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/get_user_asset_manager_assets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.AssetFromJSON));
    }
    /**
     * Gets all assets this user owns from the user asset manager.
     */
    async getUserAssetManagerAssets() {
        const response = await this.getUserAssetManagerAssetsRaw();
        return await response.value();
    }
    /**
     */
    async pairTournamentAssetsRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/pair_tournament_assets`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PairTournamentAssetsBodyToJSON(requestParameters.pairTournamentAssetsBody),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async pairTournamentAssets(requestParameters) {
        await this.pairTournamentAssetsRaw(requestParameters);
    }
    /**
     * Gets the assets for this tournament
     */
    async playerGetPairedTournamentAssetsRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Player", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/asset/player_get_paired_tournament_assets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GetPairedTournamentAssetsResponseFromJSON(jsonValue));
    }
    /**
     * Gets the assets for this tournament
     */
    async playerGetPairedTournamentAssets() {
        const response = await this.playerGetPairedTournamentAssetsRaw();
        return await response.value();
    }
    /**
     * Uploads an asset to the asset manager for admins.
     */
    async updateAssetManagerAssetRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.id !== undefined) {
            formParams.append('_id', requestParameters.id);
        }
        if (requestParameters.asset !== undefined) {
            formParams.append('asset', requestParameters.asset);
        }
        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name);
        }
        if (requestParameters.description !== undefined) {
            formParams.append('description', requestParameters.description);
        }
        const response = await this.request({
            path: `/asset/update_asset_manager_asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Uploads an asset to the asset manager for admins.
     */
    async updateAssetManagerAsset(requestParameters) {
        await this.updateAssetManagerAssetRaw(requestParameters);
    }
    /**
     * Uploads an asset to the asset manager for users.
     */
    async updateUserAssetManagerAssetRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.id !== undefined) {
            formParams.append('_id', requestParameters.id);
        }
        if (requestParameters.asset !== undefined) {
            formParams.append('asset', requestParameters.asset);
        }
        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name);
        }
        if (requestParameters.description !== undefined) {
            formParams.append('description', requestParameters.description);
        }
        const response = await this.request({
            path: `/asset/update_user_asset_manager_asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Uploads an asset to the asset manager for users.
     */
    async updateUserAssetManagerAsset(requestParameters) {
        await this.updateUserAssetManagerAssetRaw(requestParameters);
    }
    /**
     * Uploads an asset to the asset manager for a tournament.
     */
    async uploadTournamentAssetRaw(requestParameters) {
        if (requestParameters.asset === null || requestParameters.asset === undefined) {
            throw new runtime.RequiredError('asset', 'Required parameter requestParameters.asset was null or undefined when calling uploadTournamentAsset.');
        }
        if (requestParameters.tournamentID === null || requestParameters.tournamentID === undefined) {
            throw new runtime.RequiredError('tournamentID', 'Required parameter requestParameters.tournamentID was null or undefined when calling uploadTournamentAsset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.asset !== undefined) {
            formParams.append('asset', requestParameters.asset);
        }
        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name);
        }
        if (requestParameters.description !== undefined) {
            formParams.append('description', requestParameters.description);
        }
        if (requestParameters.tournamentID !== undefined) {
            formParams.append('tournamentID', requestParameters.tournamentID);
        }
        const response = await this.request({
            path: `/asset/upload_tournament_asset`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Uploads an asset to the asset manager for a tournament.
     */
    async uploadTournamentAsset(requestParameters) {
        await this.uploadTournamentAssetRaw(requestParameters);
    }
    /**
     * pipes the asset from Google Storage.
     */
    async viewAssetRaw(requestParameters) {
        if (requestParameters.urlExtension === null || requestParameters.urlExtension === undefined) {
            throw new runtime.RequiredError('urlExtension', 'Required parameter requestParameters.urlExtension was null or undefined when calling viewAsset.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/asset/{urlExtension}`.replace(`{${"urlExtension"}}`, encodeURIComponent(String(requestParameters.urlExtension))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.BlobApiResponse(response);
    }
    /**
     * pipes the asset from Google Storage.
     */
    async viewAsset(requestParameters) {
        const response = await this.viewAssetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets the base64 of a particular asset.
     */
    async viewAssetBase64Raw(requestParameters) {
        if (requestParameters.urlExtension === null || requestParameters.urlExtension === undefined) {
            throw new runtime.RequiredError('urlExtension', 'Required parameter requestParameters.urlExtension was null or undefined when calling viewAssetBase64.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/asset_base64/{urlExtension}`.replace(`{${"urlExtension"}}`, encodeURIComponent(String(requestParameters.urlExtension))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AssetBase64ResponseFromJSON(jsonValue));
    }
    /**
     * Gets the base64 of a particular asset.
     */
    async viewAssetBase64(requestParameters) {
        const response = await this.viewAssetBase64Raw(requestParameters);
        return await response.value();
    }
}
exports.AssetApi = AssetApi;
